// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bg-2";
export var aiChatCartContainerExit = "_bg-4";
export var aiChatContainerLarge = "_bg-0";
export var aiChatContainerSmall = "_bg-1";
export var aiChatIcon = "_bg-6";
export var slideInFromRight = "_bg-3";
export var slideOutToRight = "_bg-5";